;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="bd806936-b78e-412c-b74f-5b5b741892b2",e._sentryDebugIdIdentifier="sentry-dbid-bd806936-b78e-412c-b74f-5b5b741892b2")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3234],{

/***/ 32924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var dist = {};

var blocks = {};

Object.defineProperty(blocks, "__esModule", { value: true });
blocks.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS || (blocks.BLOCKS = BLOCKS = {}));

var inlines = {};

Object.defineProperty(inlines, "__esModule", { value: true });
inlines.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */
var INLINES;
(function (INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})(INLINES || (inlines.INLINES = INLINES = {}));

var marks = {};

Object.defineProperty(marks, "__esModule", { value: true });
marks.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})(MARKS || (marks.MARKS = MARKS = {}));

var schemaConstraints = {};

(function (exports) {
	var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	};
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
	var blocks_1 = blocks;
	var inlines_1 = inlines;
	var marks_1 = marks;
	/**
	 * Array of all top level block types.
	 * Only these block types can be the direct children of the document.
	 */
	exports.TOP_LEVEL_BLOCKS = [
	    blocks_1.BLOCKS.PARAGRAPH,
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	    blocks_1.BLOCKS.OL_LIST,
	    blocks_1.BLOCKS.UL_LIST,
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.QUOTE,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
	    blocks_1.BLOCKS.TABLE,
	];
	/**
	 * Array of all allowed block types inside list items
	 */
	exports.LIST_ITEM_BLOCKS = [
	    blocks_1.BLOCKS.PARAGRAPH,
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	    blocks_1.BLOCKS.OL_LIST,
	    blocks_1.BLOCKS.UL_LIST,
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.QUOTE,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
	];
	exports.TABLE_BLOCKS = [
	    blocks_1.BLOCKS.TABLE,
	    blocks_1.BLOCKS.TABLE_ROW,
	    blocks_1.BLOCKS.TABLE_CELL,
	    blocks_1.BLOCKS.TABLE_HEADER_CELL,
	];
	/**
	 * Array of all void block types
	 */
	exports.VOID_BLOCKS = [
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
	];
	/**
	 * Dictionary of all container block types, and the set block types they accept as children.
	 *
	 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
	 */
	exports.CONTAINERS = (_a = {},
	    _a[blocks_1.BLOCKS.OL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
	    _a[blocks_1.BLOCKS.UL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
	    _a[blocks_1.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
	    _a[blocks_1.BLOCKS.QUOTE] = [blocks_1.BLOCKS.PARAGRAPH],
	    _a[blocks_1.BLOCKS.TABLE] = [blocks_1.BLOCKS.TABLE_ROW],
	    _a[blocks_1.BLOCKS.TABLE_ROW] = [blocks_1.BLOCKS.TABLE_CELL, blocks_1.BLOCKS.TABLE_HEADER_CELL],
	    _a[blocks_1.BLOCKS.TABLE_CELL] = [blocks_1.BLOCKS.PARAGRAPH, blocks_1.BLOCKS.UL_LIST, blocks_1.BLOCKS.OL_LIST],
	    _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
	    _a);
	/**
	 * Array of all heading levels
	 */
	exports.HEADINGS = [
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	];
	/**
	 * Array of all block types that may contain text and inline nodes.
	 */
	exports.TEXT_CONTAINERS = __spreadArray([blocks_1.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
	/**
	 * Node types before `tables` release.
	 */
	exports.V1_NODE_TYPES = [
	    blocks_1.BLOCKS.DOCUMENT,
	    blocks_1.BLOCKS.PARAGRAPH,
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	    blocks_1.BLOCKS.OL_LIST,
	    blocks_1.BLOCKS.UL_LIST,
	    blocks_1.BLOCKS.LIST_ITEM,
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.QUOTE,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    inlines_1.INLINES.HYPERLINK,
	    inlines_1.INLINES.ENTRY_HYPERLINK,
	    inlines_1.INLINES.ASSET_HYPERLINK,
	    inlines_1.INLINES.EMBEDDED_ENTRY,
	    'text',
	];
	/**
	 * Marks before `superscript` & `subscript` release.
	 */
	exports.V1_MARKS = [marks_1.MARKS.BOLD, marks_1.MARKS.CODE, marks_1.MARKS.ITALIC, marks_1.MARKS.UNDERLINE];
	
} (schemaConstraints));

var types = {};

Object.defineProperty(types, "__esModule", { value: true });

var nodeTypes = {};

Object.defineProperty(nodeTypes, "__esModule", { value: true });

var emptyDocument = {};

Object.defineProperty(emptyDocument, "__esModule", { value: true });
emptyDocument.EMPTY_DOCUMENT = void 0;
var blocks_1$1 = blocks;
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
emptyDocument.EMPTY_DOCUMENT = {
    nodeType: blocks_1$1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks_1$1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};

var helpers = {};

Object.defineProperty(helpers, "__esModule", { value: true });
helpers.isInline = isInline;
helpers.isBlock = isBlock;
helpers.isText = isText;
var blocks_1 = blocks;
var inlines_1 = inlines;
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines_1.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks_1.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var schemas = {};

Object.defineProperty(schemas, "__esModule", { value: true });
schemas.getSchemaWithNodeType = getSchemaWithNodeType;
function getSchemaWithNodeType(nodeType) {
    try {
        return commonjsRequire("./generated/".concat(nodeType, ".json"));
    }
    catch (error) {
        throw new Error("Schema for nodeType \"".concat(nodeType, "\" was not found."));
    }
}

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getSchemaWithNodeType = exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
	var blocks_1 = blocks;
	Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks_1.BLOCKS; } });
	var inlines_1 = inlines;
	Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines_1.INLINES; } });
	var marks_1 = marks;
	Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return marks_1.MARKS; } });
	__exportStar(schemaConstraints, exports);
	__exportStar(types, exports);
	__exportStar(nodeTypes, exports);
	var emptyDocument_1 = emptyDocument;
	Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return emptyDocument_1.EMPTY_DOCUMENT; } });
	var helpers$1 = __importStar(helpers);
	exports.helpers = helpers$1;
	var schemas_1 = schemas;
	Object.defineProperty(exports, "getSchemaWithNodeType", { enumerable: true, get: function () { return schemas_1.getSchemaWithNodeType; } });
	
} (dist));

/**
 * Returns the text value of a rich text document.
 *
 * NB: This can be applied to non text node of a structured text document,
 * hence the flexible typing.
 */
function documentToPlainTextString(rootNode, blockDivisor) {
    if (blockDivisor === void 0) { blockDivisor = ' '; }
    if (!rootNode || !rootNode.content || !Array.isArray(rootNode.content)) {
        /**
         * Handles edge cases, such as when the value is not set in the CMA or the
         * field has not been properly validated, e.g. because of a user extension.
         * Note that we are nevertheless strictly type-casting `rootNode` as
         * Block | Inline. Valid rich text documents (and their branch block nodes)
         * should never lack a Node[] `content` property.
         */
        return '';
    }
    /**
     * Algorithm notes: We only want to apply spacing when a node is part of a
     * sequence. This is tricky because nodes can often be deeply nested within
     * non-semantic content arrays. For example, to get the text value of an
     * unordered list, we have to traverse like so:
     *
     * {
     *   nodeType: BLOCKS.UL_LIST,
     *   data: {},
     *   content: [
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'List ', marks: [] },
     *           { nodeType: 'text', data: {}, value: 'item', marks: [{ type: 'bold' }] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.HR,
     *         data: {},
     *         content: [],
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data:
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Yet another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *   }]
     * }
     *
     * We want there to be a space between 'List item' and 'Another list item' (to
     * denote a visual line break, which conventionally appears between non-text
     * node sequences) but not a redundant space between 'List ' and 'item'.
     * Moreover, we want just a _singular_ space between 'Another list item' and
     * 'Yet another list item' - the non-semantic HR between the two nodes should
     * not denote an additional space.
     */
    return rootNode.content.reduce(function (acc, node, i) {
        var nodeTextValue;
        if (dist.helpers.isText(node)) {
            nodeTextValue = node.value;
        }
        else if (dist.helpers.isBlock(node) || dist.helpers.isInline(node)) {
            nodeTextValue = documentToPlainTextString(node, blockDivisor);
            if (!nodeTextValue.length) {
                return acc;
            }
        }
        var nextNode = rootNode.content[i + 1];
        var isNextNodeBlock = nextNode && dist.helpers.isBlock(nextNode);
        var divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}

exports.a = documentToPlainTextString;
//# sourceMappingURL=rich-text-plain-text-renderer.es5.js.map


/***/ }),

/***/ 74129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var React = __webpack_require__(67294);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var dist = {};

var blocks = {};

Object.defineProperty(blocks, "__esModule", { value: true });
blocks.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS || (blocks.BLOCKS = BLOCKS = {}));

var inlines = {};

Object.defineProperty(inlines, "__esModule", { value: true });
inlines.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */
var INLINES;
(function (INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})(INLINES || (inlines.INLINES = INLINES = {}));

var marks = {};

Object.defineProperty(marks, "__esModule", { value: true });
marks.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})(MARKS || (marks.MARKS = MARKS = {}));

var schemaConstraints = {};

(function (exports) {
	var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	};
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
	var blocks_1 = blocks;
	var inlines_1 = inlines;
	var marks_1 = marks;
	/**
	 * Array of all top level block types.
	 * Only these block types can be the direct children of the document.
	 */
	exports.TOP_LEVEL_BLOCKS = [
	    blocks_1.BLOCKS.PARAGRAPH,
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	    blocks_1.BLOCKS.OL_LIST,
	    blocks_1.BLOCKS.UL_LIST,
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.QUOTE,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
	    blocks_1.BLOCKS.TABLE,
	];
	/**
	 * Array of all allowed block types inside list items
	 */
	exports.LIST_ITEM_BLOCKS = [
	    blocks_1.BLOCKS.PARAGRAPH,
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	    blocks_1.BLOCKS.OL_LIST,
	    blocks_1.BLOCKS.UL_LIST,
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.QUOTE,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
	];
	exports.TABLE_BLOCKS = [
	    blocks_1.BLOCKS.TABLE,
	    blocks_1.BLOCKS.TABLE_ROW,
	    blocks_1.BLOCKS.TABLE_CELL,
	    blocks_1.BLOCKS.TABLE_HEADER_CELL,
	];
	/**
	 * Array of all void block types
	 */
	exports.VOID_BLOCKS = [
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
	];
	/**
	 * Dictionary of all container block types, and the set block types they accept as children.
	 *
	 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
	 */
	exports.CONTAINERS = (_a = {},
	    _a[blocks_1.BLOCKS.OL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
	    _a[blocks_1.BLOCKS.UL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
	    _a[blocks_1.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
	    _a[blocks_1.BLOCKS.QUOTE] = [blocks_1.BLOCKS.PARAGRAPH],
	    _a[blocks_1.BLOCKS.TABLE] = [blocks_1.BLOCKS.TABLE_ROW],
	    _a[blocks_1.BLOCKS.TABLE_ROW] = [blocks_1.BLOCKS.TABLE_CELL, blocks_1.BLOCKS.TABLE_HEADER_CELL],
	    _a[blocks_1.BLOCKS.TABLE_CELL] = [blocks_1.BLOCKS.PARAGRAPH, blocks_1.BLOCKS.UL_LIST, blocks_1.BLOCKS.OL_LIST],
	    _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
	    _a);
	/**
	 * Array of all heading levels
	 */
	exports.HEADINGS = [
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	];
	/**
	 * Array of all block types that may contain text and inline nodes.
	 */
	exports.TEXT_CONTAINERS = __spreadArray([blocks_1.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
	/**
	 * Node types before `tables` release.
	 */
	exports.V1_NODE_TYPES = [
	    blocks_1.BLOCKS.DOCUMENT,
	    blocks_1.BLOCKS.PARAGRAPH,
	    blocks_1.BLOCKS.HEADING_1,
	    blocks_1.BLOCKS.HEADING_2,
	    blocks_1.BLOCKS.HEADING_3,
	    blocks_1.BLOCKS.HEADING_4,
	    blocks_1.BLOCKS.HEADING_5,
	    blocks_1.BLOCKS.HEADING_6,
	    blocks_1.BLOCKS.OL_LIST,
	    blocks_1.BLOCKS.UL_LIST,
	    blocks_1.BLOCKS.LIST_ITEM,
	    blocks_1.BLOCKS.HR,
	    blocks_1.BLOCKS.QUOTE,
	    blocks_1.BLOCKS.EMBEDDED_ENTRY,
	    blocks_1.BLOCKS.EMBEDDED_ASSET,
	    inlines_1.INLINES.HYPERLINK,
	    inlines_1.INLINES.ENTRY_HYPERLINK,
	    inlines_1.INLINES.ASSET_HYPERLINK,
	    inlines_1.INLINES.EMBEDDED_ENTRY,
	    'text',
	];
	/**
	 * Marks before `superscript` & `subscript` release.
	 */
	exports.V1_MARKS = [marks_1.MARKS.BOLD, marks_1.MARKS.CODE, marks_1.MARKS.ITALIC, marks_1.MARKS.UNDERLINE];
	
} (schemaConstraints));

var types = {};

Object.defineProperty(types, "__esModule", { value: true });

var nodeTypes = {};

Object.defineProperty(nodeTypes, "__esModule", { value: true });

var emptyDocument = {};

Object.defineProperty(emptyDocument, "__esModule", { value: true });
emptyDocument.EMPTY_DOCUMENT = void 0;
var blocks_1$1 = blocks;
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
emptyDocument.EMPTY_DOCUMENT = {
    nodeType: blocks_1$1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks_1$1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};

var helpers = {};

Object.defineProperty(helpers, "__esModule", { value: true });
helpers.isInline = isInline;
helpers.isBlock = isBlock;
helpers.isText = isText;
var blocks_1 = blocks;
var inlines_1 = inlines;
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines_1.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks_1.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var schemas = {};

Object.defineProperty(schemas, "__esModule", { value: true });
schemas.getSchemaWithNodeType = getSchemaWithNodeType;
function getSchemaWithNodeType(nodeType) {
    try {
        return commonjsRequire("./generated/".concat(nodeType, ".json"));
    }
    catch (error) {
        throw new Error("Schema for nodeType \"".concat(nodeType, "\" was not found."));
    }
}

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getSchemaWithNodeType = exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
	var blocks_1 = blocks;
	Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks_1.BLOCKS; } });
	var inlines_1 = inlines;
	Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines_1.INLINES; } });
	var marks_1 = marks;
	Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return marks_1.MARKS; } });
	__exportStar(schemaConstraints, exports);
	__exportStar(types, exports);
	__exportStar(nodeTypes, exports);
	var emptyDocument_1 = emptyDocument;
	Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return emptyDocument_1.EMPTY_DOCUMENT; } });
	var helpers$1 = __importStar(helpers);
	exports.helpers = helpers$1;
	var schemas_1 = schemas;
	Object.defineProperty(exports, "getSchemaWithNodeType", { enumerable: true, get: function () { return schemas_1.getSchemaWithNodeType; } });
	
} (dist));

function appendKeyToValidElement(element, key) {
    if (React.isValidElement(element) && element.key === null) {
        return React.cloneElement(element, { key: key });
    }
    return element;
}

function nodeListToReactComponents(nodes, options) {
    return nodes.map(function (node, index) {
        return appendKeyToValidElement(nodeToReactComponent(node, options), index);
    });
}
function nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
    if (dist.helpers.isText(node)) {
        var nodeValue = renderText ? renderText(node.value) : node.value;
        // Preserving whitespace is only supported with the default transformations.
        if (preserveWhitespace && !renderText) {
            // Preserve multiple spaces.
            nodeValue = nodeValue.replace(/ {2,}/g, function (match) { return '\u00A0'.repeat(match.length); });
            // Preserve line breaks.
            var lines_1 = nodeValue.split('\n');
            var jsxLines_1 = [];
            lines_1.forEach(function (line, index) {
                jsxLines_1.push(line);
                if (index !== lines_1.length - 1) {
                    jsxLines_1.push(React.createElement("br", null));
                }
            });
            nodeValue = jsxLines_1;
        }
        return node.marks.reduce(function (value, mark) {
            if (!renderMark[mark.type]) {
                return value;
            }
            return renderMark[mark.type](value);
        }, nodeValue);
    }
    else {
        var children = nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) {
            return React.createElement(React.Fragment, null, children);
        }
        return renderNode[node.nodeType](node, children);
    }
}

var _a, _b;
var defaultNodeRenderers = (_a = {},
    _a[dist.BLOCKS.DOCUMENT] = function (node, children) { return children; },
    _a[dist.BLOCKS.PARAGRAPH] = function (node, children) { return React.createElement("p", null, children); },
    _a[dist.BLOCKS.HEADING_1] = function (node, children) { return React.createElement("h1", null, children); },
    _a[dist.BLOCKS.HEADING_2] = function (node, children) { return React.createElement("h2", null, children); },
    _a[dist.BLOCKS.HEADING_3] = function (node, children) { return React.createElement("h3", null, children); },
    _a[dist.BLOCKS.HEADING_4] = function (node, children) { return React.createElement("h4", null, children); },
    _a[dist.BLOCKS.HEADING_5] = function (node, children) { return React.createElement("h5", null, children); },
    _a[dist.BLOCKS.HEADING_6] = function (node, children) { return React.createElement("h6", null, children); },
    _a[dist.BLOCKS.EMBEDDED_ENTRY] = function (node, children) { return React.createElement("div", null, children); },
    _a[dist.BLOCKS.EMBEDDED_RESOURCE] = function (node, children) { return React.createElement("div", null, children); },
    _a[dist.BLOCKS.UL_LIST] = function (node, children) { return React.createElement("ul", null, children); },
    _a[dist.BLOCKS.OL_LIST] = function (node, children) { return React.createElement("ol", null, children); },
    _a[dist.BLOCKS.LIST_ITEM] = function (node, children) { return React.createElement("li", null, children); },
    _a[dist.BLOCKS.QUOTE] = function (node, children) { return React.createElement("blockquote", null, children); },
    _a[dist.BLOCKS.HR] = function () { return React.createElement("hr", null); },
    _a[dist.BLOCKS.TABLE] = function (node, children) { return (React.createElement("table", null,
        React.createElement("tbody", null, children))); },
    _a[dist.BLOCKS.TABLE_ROW] = function (node, children) { return React.createElement("tr", null, children); },
    _a[dist.BLOCKS.TABLE_HEADER_CELL] = function (node, children) { return React.createElement("th", null, children); },
    _a[dist.BLOCKS.TABLE_CELL] = function (node, children) { return React.createElement("td", null, children); },
    _a[dist.INLINES.ASSET_HYPERLINK] = function (node) { return defaultInline(dist.INLINES.ASSET_HYPERLINK, node); },
    _a[dist.INLINES.ENTRY_HYPERLINK] = function (node) { return defaultInline(dist.INLINES.ENTRY_HYPERLINK, node); },
    _a[dist.INLINES.RESOURCE_HYPERLINK] = function (node) {
        return defaultInlineResource(dist.INLINES.RESOURCE_HYPERLINK, node);
    },
    _a[dist.INLINES.EMBEDDED_ENTRY] = function (node) { return defaultInline(dist.INLINES.EMBEDDED_ENTRY, node); },
    _a[dist.INLINES.EMBEDDED_RESOURCE] = function (node, _children) {
        return defaultInlineResource(dist.INLINES.EMBEDDED_RESOURCE, node);
    },
    _a[dist.INLINES.HYPERLINK] = function (node, children) { return React.createElement("a", { href: node.data.uri }, children); },
    _a);
var defaultMarkRenderers = (_b = {},
    _b[dist.MARKS.BOLD] = function (text) { return React.createElement("b", null, text); },
    _b[dist.MARKS.ITALIC] = function (text) { return React.createElement("i", null, text); },
    _b[dist.MARKS.UNDERLINE] = function (text) { return React.createElement("u", null, text); },
    _b[dist.MARKS.CODE] = function (text) { return React.createElement("code", null, text); },
    _b[dist.MARKS.SUPERSCRIPT] = function (text) { return React.createElement("sup", null, text); },
    _b[dist.MARKS.SUBSCRIPT] = function (text) { return React.createElement("sub", null, text); },
    _b[dist.MARKS.STRIKETHROUGH] = function (text) { return React.createElement("s", null, text); },
    _b);
function defaultInline(type, node) {
    return (React.createElement("span", { key: node.data.target.sys.id },
        "type: ",
        node.nodeType,
        " id: ",
        node.data.target.sys.id));
}
function defaultInlineResource(type, node) {
    return (React.createElement("span", { key: node.data.target.sys.urn },
        "type: ",
        node.nodeType,
        " urn: ",
        node.data.target.sys.urn));
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */
function documentToReactComponents(richTextDocument, options) {
    if (options === void 0) { options = {}; }
    if (!richTextDocument) {
        return null;
    }
    return nodeToReactComponent(richTextDocument, {
        renderNode: __assign(__assign({}, defaultNodeRenderers), options.renderNode),
        renderMark: __assign(__assign({}, defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
        preserveWhitespace: options.preserveWhitespace,
    });
}

exports.h = documentToReactComponents;
//# sourceMappingURL=rich-text-react-renderer.es5.js.map


/***/ }),

/***/ 20549:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS || (exports.BLOCKS = BLOCKS = {}));
//# sourceMappingURL=blocks.js.map

/***/ }),

/***/ 51928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EMPTY_DOCUMENT = void 0;
var blocks_1 = __webpack_require__(20549);
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
exports.EMPTY_DOCUMENT = {
    nodeType: blocks_1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks_1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
//# sourceMappingURL=emptyDocument.js.map

/***/ }),

/***/ 86061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isInline = isInline;
exports.isBlock = isBlock;
exports.isText = isText;
var blocks_1 = __webpack_require__(20549);
var inlines_1 = __webpack_require__(7845);
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines_1.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks_1.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 86437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSchemaWithNodeType = exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
var blocks_1 = __webpack_require__(20549);
Object.defineProperty(exports, "BLOCKS", ({ enumerable: true, get: function () { return blocks_1.BLOCKS; } }));
var inlines_1 = __webpack_require__(7845);
Object.defineProperty(exports, "INLINES", ({ enumerable: true, get: function () { return inlines_1.INLINES; } }));
var marks_1 = __webpack_require__(31376);
Object.defineProperty(exports, "MARKS", ({ enumerable: true, get: function () { return marks_1.MARKS; } }));
__exportStar(__webpack_require__(97951), exports);
__exportStar(__webpack_require__(80167), exports);
__exportStar(__webpack_require__(11911), exports);
var emptyDocument_1 = __webpack_require__(51928);
Object.defineProperty(exports, "EMPTY_DOCUMENT", ({ enumerable: true, get: function () { return emptyDocument_1.EMPTY_DOCUMENT; } }));
var helpers = __importStar(__webpack_require__(86061));
exports.helpers = helpers;
var schemas_1 = __webpack_require__(71024);
Object.defineProperty(exports, "getSchemaWithNodeType", ({ enumerable: true, get: function () { return schemas_1.getSchemaWithNodeType; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7845:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */
var INLINES;
(function (INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})(INLINES || (exports.INLINES = INLINES = {}));
//# sourceMappingURL=inlines.js.map

/***/ }),

/***/ 31376:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})(MARKS || (exports.MARKS = MARKS = {}));
//# sourceMappingURL=marks.js.map

/***/ }),

/***/ 11911:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=nodeTypes.js.map

/***/ }),

/***/ 97951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
var blocks_1 = __webpack_require__(20549);
var inlines_1 = __webpack_require__(7845);
var marks_1 = __webpack_require__(31376);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
    blocks_1.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
];
exports.TABLE_BLOCKS = [
    blocks_1.BLOCKS.TABLE,
    blocks_1.BLOCKS.TABLE_ROW,
    blocks_1.BLOCKS.TABLE_CELL,
    blocks_1.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks_1.BLOCKS.OL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.UL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks_1.BLOCKS.QUOTE] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE] = [blocks_1.BLOCKS.TABLE_ROW],
    _a[blocks_1.BLOCKS.TABLE_ROW] = [blocks_1.BLOCKS.TABLE_CELL, blocks_1.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks_1.BLOCKS.TABLE_CELL] = [blocks_1.BLOCKS.PARAGRAPH, blocks_1.BLOCKS.UL_LIST, blocks_1.BLOCKS.OL_LIST],
    _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks_1.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks_1.BLOCKS.DOCUMENT,
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.LIST_ITEM,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    inlines_1.INLINES.HYPERLINK,
    inlines_1.INLINES.ENTRY_HYPERLINK,
    inlines_1.INLINES.ASSET_HYPERLINK,
    inlines_1.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.MARKS.BOLD, marks_1.MARKS.CODE, marks_1.MARKS.ITALIC, marks_1.MARKS.UNDERLINE];
//# sourceMappingURL=schemaConstraints.js.map

/***/ }),

/***/ 71024:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSchemaWithNodeType = getSchemaWithNodeType;
function getSchemaWithNodeType(nodeType) {
    try {
        return __webpack_require__(37507)("./".concat(nodeType, ".json"));
    }
    catch (error) {
        throw new Error("Schema for nodeType \"".concat(nodeType, "\" was not found."));
    }
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 80167:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 70879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ de; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return 'vor ' + result;
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018
};

var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(88486);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/localize/index.js

var eraValues = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var formattingMonthValues = {
  narrow: monthValues.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: monthValues.wide
};
var dayValues = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    formattingValues: formattingMonthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(76723);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(60974);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`
  }
};

var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
var locale = {
  code: 'de',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var de = (locale);

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 25994:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/AssetHyperlink","definitions":{"AssetHyperlink":{"type":"object","properties":{"nodeType":{"type":"string","enum":["asset-hyperlink"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/Link<\\"Asset\\">"}},"additionalProperties":false,"required":["target"]},"content":{"type":"array","items":{"$ref":"#/definitions/Text"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Link<\\"Asset\\">":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["Link"]},"linkType":{"type":"string","enum":["Asset"]},"id":{"type":"string"}},"additionalProperties":false,"required":["id","linkType","type"]}},"additionalProperties":false,"required":["sys"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 62559:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Quote","definitions":{"Quote":{"type":"object","properties":{"nodeType":{"type":"string","enum":["blockquote"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"$ref":"#/definitions/Paragraph"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Paragraph":{"type":"object","properties":{"nodeType":{"type":"string","enum":["paragraph"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 51734:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Document","definitions":{"Document":{"type":"object","properties":{"nodeType":{"type":"string","enum":["document"]},"content":{"type":"array","items":{"$ref":"#/definitions/TopLevelBlock"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"TopLevelBlock":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/TopLevelBlockEnum"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"TopLevelBlockEnum":{"enum":["blockquote","embedded-asset-block","embedded-entry-block","embedded-resource-block","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","hr","ordered-list","paragraph","table","unordered-list"],"type":"string"},"Block":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/BLOCKS"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"BLOCKS":{"description":"Map of all Contentful block types. Blocks contain inline or block nodes.","type":"string","enum":["document","paragraph","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","ordered-list","unordered-list","list-item","hr","blockquote","embedded-entry-block","embedded-asset-block","embedded-resource-block","table","table-row","table-cell","table-header-cell"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 1220:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/AssetLinkBlock","definitions":{"AssetLinkBlock":{"type":"object","properties":{"nodeType":{"type":"string","enum":["embedded-asset-block"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/Link<\\"Asset\\">"}},"additionalProperties":false,"required":["target"]},"content":{"maxItems":0,"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Link<\\"Asset\\">":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["Link"]},"linkType":{"type":"string","enum":["Asset"]},"id":{"type":"string"}},"additionalProperties":false,"required":["id","linkType","type"]}},"additionalProperties":false,"required":["sys"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 72258:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/EntryLinkBlock","definitions":{"EntryLinkBlock":{"type":"object","properties":{"nodeType":{"type":"string","enum":["embedded-entry-block"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/Link<\\"Entry\\">"}},"additionalProperties":false,"required":["target"]},"content":{"maxItems":0,"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Link<\\"Entry\\">":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["Link"]},"linkType":{"type":"string","enum":["Entry"]},"id":{"type":"string"}},"additionalProperties":false,"required":["id","linkType","type"]}},"additionalProperties":false,"required":["sys"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 92204:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/EntryLinkInline","definitions":{"EntryLinkInline":{"type":"object","properties":{"nodeType":{"type":"string","enum":["embedded-entry-inline"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/Link<\\"Entry\\">"}},"additionalProperties":false,"required":["target"]},"content":{"maxItems":0,"type":"array","items":{"$ref":"#/definitions/Text"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Link<\\"Entry\\">":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["Link"]},"linkType":{"type":"string","enum":["Entry"]},"id":{"type":"string"}},"additionalProperties":false,"required":["id","linkType","type"]}},"additionalProperties":false,"required":["sys"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 20546:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/ResourceLinkBlock","definitions":{"ResourceLinkBlock":{"type":"object","properties":{"nodeType":{"type":"string","enum":["embedded-resource-block"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/ResourceLink"}},"additionalProperties":false,"required":["target"]},"content":{"maxItems":0,"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ResourceLink":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["ResourceLink"]},"linkType":{"type":"string","enum":["Contentful:Entry"]},"urn":{"type":"string"}},"additionalProperties":false,"required":["linkType","type","urn"]}},"additionalProperties":false,"required":["sys"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 8242:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/ResourceLinkInline","definitions":{"ResourceLinkInline":{"type":"object","properties":{"nodeType":{"type":"string","enum":["embedded-resource-inline"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/ResourceLink"}},"additionalProperties":false,"required":["target"]},"content":{"maxItems":0,"type":"array","items":{"$ref":"#/definitions/Text"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ResourceLink":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["ResourceLink"]},"linkType":{"type":"string","enum":["Contentful:Entry"]},"urn":{"type":"string"}},"additionalProperties":false,"required":["linkType","type","urn"]}},"additionalProperties":false,"required":["sys"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 6502:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/EntryHyperlink","definitions":{"EntryHyperlink":{"type":"object","properties":{"nodeType":{"type":"string","enum":["entry-hyperlink"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/Link<\\"Entry\\">"}},"additionalProperties":false,"required":["target"]},"content":{"type":"array","items":{"$ref":"#/definitions/Text"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Link<\\"Entry\\">":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["Link"]},"linkType":{"type":"string","enum":["Entry"]},"id":{"type":"string"}},"additionalProperties":false,"required":["id","linkType","type"]}},"additionalProperties":false,"required":["sys"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 92813:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Heading1","definitions":{"Heading1":{"type":"object","properties":{"nodeType":{"type":"string","enum":["heading-1"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 45080:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Heading2","definitions":{"Heading2":{"type":"object","properties":{"nodeType":{"type":"string","enum":["heading-2"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 86423:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Heading3","definitions":{"Heading3":{"type":"object","properties":{"nodeType":{"type":"string","enum":["heading-3"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 34942:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Heading4","definitions":{"Heading4":{"type":"object","properties":{"nodeType":{"type":"string","enum":["heading-4"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 95579:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Heading5","definitions":{"Heading5":{"type":"object","properties":{"nodeType":{"type":"string","enum":["heading-5"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 50705:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Heading6","definitions":{"Heading6":{"type":"object","properties":{"nodeType":{"type":"string","enum":["heading-6"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 37121:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Hr","definitions":{"Hr":{"type":"object","properties":{"nodeType":{"type":"string","enum":["hr"]},"data":{"maxItems":0,"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 13165:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Hyperlink","definitions":{"Hyperlink":{"type":"object","properties":{"nodeType":{"type":"string","enum":["hyperlink"]},"data":{"type":"object","properties":{"uri":{"type":"string"}},"additionalProperties":false,"required":["uri"]},"content":{"type":"array","items":{"$ref":"#/definitions/Text"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 38094:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/ListItem","definitions":{"ListItem":{"type":"object","properties":{"nodeType":{"type":"string","enum":["list-item"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"$ref":"#/definitions/ListItemBlock"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItemBlock":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/ListItemBlockEnum"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItemBlockEnum":{"enum":["blockquote","embedded-asset-block","embedded-entry-block","embedded-resource-block","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","hr","ordered-list","paragraph","unordered-list"],"type":"string"},"Block":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/BLOCKS"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"BLOCKS":{"description":"Map of all Contentful block types. Blocks contain inline or block nodes.","type":"string","enum":["document","paragraph","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","ordered-list","unordered-list","list-item","hr","blockquote","embedded-entry-block","embedded-asset-block","embedded-resource-block","table","table-row","table-cell","table-header-cell"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 28122:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/OrderedList","definitions":{"OrderedList":{"type":"object","properties":{"nodeType":{"type":"string","enum":["ordered-list"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"$ref":"#/definitions/ListItem"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItem":{"type":"object","properties":{"nodeType":{"type":"string","enum":["list-item"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"$ref":"#/definitions/ListItemBlock"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItemBlock":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/ListItemBlockEnum"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItemBlockEnum":{"enum":["blockquote","embedded-asset-block","embedded-entry-block","embedded-resource-block","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","hr","ordered-list","paragraph","unordered-list"],"type":"string"},"Block":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/BLOCKS"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"BLOCKS":{"description":"Map of all Contentful block types. Blocks contain inline or block nodes.","type":"string","enum":["document","paragraph","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","ordered-list","unordered-list","list-item","hr","blockquote","embedded-entry-block","embedded-asset-block","embedded-resource-block","table","table-row","table-cell","table-header-cell"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 38986:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Paragraph","definitions":{"Paragraph":{"type":"object","properties":{"nodeType":{"type":"string","enum":["paragraph"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 3105:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/ResourceHyperlink","definitions":{"ResourceHyperlink":{"type":"object","properties":{"nodeType":{"type":"string","enum":["resource-hyperlink"]},"data":{"type":"object","properties":{"target":{"$ref":"#/definitions/ResourceLink"}},"additionalProperties":false,"required":["target"]},"content":{"type":"array","items":{"$ref":"#/definitions/Text"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ResourceLink":{"type":"object","properties":{"sys":{"type":"object","properties":{"type":{"type":"string","enum":["ResourceLink"]},"linkType":{"type":"string","enum":["Contentful:Entry"]},"urn":{"type":"string"}},"additionalProperties":false,"required":["linkType","type","urn"]}},"additionalProperties":false,"required":["sys"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 79924:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/TableCell","definitions":{"TableCell":{"type":"object","properties":{"nodeType":{"enum":["table-cell","table-header-cell"],"type":"string"},"data":{"type":"object","properties":{"colspan":{"type":"number"},"rowspan":{"type":"number"}},"additionalProperties":false},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/Paragraph"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Paragraph":{"type":"object","properties":{"nodeType":{"type":"string","enum":["paragraph"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 91787:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/TableHeaderCell","definitions":{"TableHeaderCell":{"type":"object","properties":{"nodeType":{"type":"string","enum":["table-header-cell"]},"data":{"type":"object","properties":{"colspan":{"type":"number"},"rowspan":{"type":"number"}},"additionalProperties":false},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/Paragraph"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Paragraph":{"type":"object","properties":{"nodeType":{"type":"string","enum":["paragraph"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 75531:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/TableRow","definitions":{"TableRow":{"type":"object","properties":{"nodeType":{"type":"string","enum":["table-row"]},"data":{"type":"object","properties":{}},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/TableCell"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"TableCell":{"type":"object","properties":{"nodeType":{"enum":["table-cell","table-header-cell"],"type":"string"},"data":{"type":"object","properties":{"colspan":{"type":"number"},"rowspan":{"type":"number"}},"additionalProperties":false},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/Paragraph"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Paragraph":{"type":"object","properties":{"nodeType":{"type":"string","enum":["paragraph"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 39269:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Table","definitions":{"Table":{"type":"object","properties":{"nodeType":{"type":"string","enum":["table"]},"data":{"type":"object","properties":{}},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/TableRow"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"TableRow":{"type":"object","properties":{"nodeType":{"type":"string","enum":["table-row"]},"data":{"type":"object","properties":{}},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/TableCell"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"TableCell":{"type":"object","properties":{"nodeType":{"enum":["table-cell","table-header-cell"],"type":"string"},"data":{"type":"object","properties":{"colspan":{"type":"number"},"rowspan":{"type":"number"}},"additionalProperties":false},"content":{"minItems":1,"type":"array","items":{"$ref":"#/definitions/Paragraph"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Paragraph":{"type":"object","properties":{"nodeType":{"type":"string","enum":["paragraph"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}}},"additionalProperties":false,"required":["content","data","nodeType"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 63022:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/Text","definitions":{"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ }),

/***/ 58500:
/***/ (function(module) {

module.exports = JSON.parse('{"$ref":"#/definitions/UnorderedList","definitions":{"UnorderedList":{"type":"object","properties":{"nodeType":{"type":"string","enum":["unordered-list"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"$ref":"#/definitions/ListItem"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItem":{"type":"object","properties":{"nodeType":{"type":"string","enum":["list-item"]},"data":{"type":"object","properties":{}},"content":{"type":"array","items":{"$ref":"#/definitions/ListItemBlock"}}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItemBlock":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/ListItemBlockEnum"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"ListItemBlockEnum":{"enum":["blockquote","embedded-asset-block","embedded-entry-block","embedded-resource-block","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","hr","ordered-list","paragraph","unordered-list"],"type":"string"},"Block":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/BLOCKS"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Block"},{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"BLOCKS":{"description":"Map of all Contentful block types. Blocks contain inline or block nodes.","type":"string","enum":["document","paragraph","heading-1","heading-2","heading-3","heading-4","heading-5","heading-6","ordered-list","unordered-list","list-item","hr","blockquote","embedded-entry-block","embedded-asset-block","embedded-resource-block","table","table-row","table-cell","table-header-cell"]},"Inline":{"type":"object","properties":{"nodeType":{"$ref":"#/definitions/INLINES"},"content":{"type":"array","items":{"anyOf":[{"$ref":"#/definitions/Inline"},{"$ref":"#/definitions/Text"}]}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["content","data","nodeType"]},"INLINES":{"description":"Map of all Contentful inline types. Inline contain inline or text nodes.","type":"string","enum":["asset-hyperlink","embedded-entry-inline","embedded-resource-inline","entry-hyperlink","hyperlink","resource-hyperlink"]},"Text":{"type":"object","properties":{"nodeType":{"type":"string","enum":["text"]},"value":{"type":"string"},"marks":{"type":"array","items":{"$ref":"#/definitions/Mark"}},"data":{"$ref":"#/definitions/NodeData"}},"additionalProperties":false,"required":["data","marks","nodeType","value"]},"Mark":{"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":["type"]},"NodeData":{"additionalProperties":true,"type":"object"}},"$schema":"http://json-schema.org/draft-07/schema#"}');

/***/ })

}]);